import axios from "axios";

export function updateScholarshipAwards(documentId) {
    return axios.put("/api/services/app/StudentProfile/UpdateScholarshipAwards", { id: documentId });
}
